<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="vr__bg"
          style="flex: 0 0 96.5%; border-radius: 15px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="row align-items-center" style="height: 100%">
            <div class="col-md-8">
              <div
                class="transaction_period_text text-center branch__sales__text"
                style="font-size: 22px; min-height: 200px"
              >
                <h3 class="our__branches__banner__title">
                  <img src="@/assets/img/tanks_icon.png" class="mr-3" />
                  {{ $t("text.tankReport.title") }}
                </h3>
              </div>
            </div>
            <div class="col-md-3 drop_down_input_group">
              <div class="drop_down_section mt-2 mr-2">
                <div
                  class="drop_down_div align-items-center tank-report-dropdown"
                >
                  <vue-ctk-date-time-picker
                    v-model="dateRange"
                    :max-date="maxDate"
                    :range="true"
                    :autoClose="true"
                    :locale="this.$root.$i18n.locale"
                    :custom-shortcuts="customShortcuts"
                    :color="$store.getters.getDatePickerColor"
                    format="DDMMYYYY"
                    formatted="DD/MM/YYYY"
                    :label="$t('text.calendar.dateRange')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-2 mt-3">
        <section>
          <div class="dashboard__table__section mt-3">
            <div class="branch__sales__text_header">
              <highcharts
                :options="tankReportsSplineOption"
                class=""
              ></highcharts>
              <TableLoader :showLoader="showLoader" />
            </div>
          </div>
        </section>
      </div>
      <div class="section-2 mt-3">
        <section>
          <div class="dashboard__table__section mt-3">
            <div class="branch__sales__text_header">
              <div class="row top_section_row" style="border-radius: 20px">
                <div class="col-md-8">
                  <span class="sec_text_color">
                    {{ $t("text.tankReport.reportBetween") }}
                    {{
                      $d(new Date(startDate), "short", this.$root.$i18n.locale)
                    }}
                    {{ $t("text.and.text") }}
                    {{
                      $d(new Date(endDate), "short", this.$root.$i18n.locale)
                    }}
                  </span>
                </div>
                <div class="col-md-4 text-right">
                  <!-- <button class="show_more_button remove_text_decoration"  @click="downloadWithCSS">
                        Download Sales Report
                  </button>-->
                </div>
              </div>
              <ejs-grid
                v-show="!showLoader"
                ref="dataGrid"
                :created="refreshGrid"
                :allowPaging="true"
                :allowSorting="true"
                :pageSettings="pageSettings"
                :toolbar="toolbar"
                :searchSettings="search"
                :allowExcelExport="true"
                :allowPdfExport="true"
                :toolbarClick="toolbarClick"
                :locale="usedLang"
              >
                <e-columns>
                  <e-column width="40" field="index" headerText="#"></e-column>
                  <e-column
                    field="tankName"
                    width="180"
                    :headerText="$t('text.tankReport.tankName')"
                  ></e-column>
                  <e-column
                    format="N2"
                    field="volumeSold"
                    width="180"
                    :headerText="$t('text.tankReport.saleVolume')"
                  ></e-column>
                  <e-column
                    format="N2"
                    field="volumeFilled"
                    width="180"
                    :headerText="$t('text.tankReport.volumeRefilled')"
                  ></e-column>
                  <e-column
                    format="N2"
                    field="openingDip"
                    width="180"
                    :headerText="$t('text.tankReport.openingVolume')"
                  ></e-column>
                  <e-column
                    format="N2"
                    field="closingDip"
                    width="180"
                    :headerText="$t('text.tankReport.closingVolume')"
                  ></e-column>
                </e-columns>
              </ejs-grid>
              <TableLoader :showLoader="showLoader" />
            </div>
          </div>
        </section>
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/BecomeDealer.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import { VueApexCharts } from "apexcharts";
import { Chart } from "highcharts-vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "Tank Reports",
  components: {
    MasterLayout,
    TableLoader,
    Highcharts: Chart,
    VueApexCharts,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      backgroundUrl,
      cardBackgroundUrl,
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      showLoader: false,
      branch: {},
      branchId: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      tankReportsSplineOption: {
        chart: {
          type: "column",
        },
        title: {
          text: this.$t("text.tankReport.title"),
        },
        subtitle: {
          // text: 'Source: WorldClimate.com'
        },
        xAxis: {
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t("text.tankReport.totalVolume"),
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [],
      },
    };
  },
  created() {
    document.title = "Tanks Reports:: Epump Retail Outlet";
    this.showLoader = true;
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Tanks Reports:: ${branch.name} Retail Outlet`;
    });
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
  },
  beforeDestroy() {},

  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        if (this.$route.query.branchId) {
          this.branchId = this.branch.id;
          if (this.branchId !== null) {
            this.getTankReports();
          }
        } else {
          if (this.branch.id) {
            this.branchId = this.branch.id;
          }
          if (this.branchId !== null) {
            this.getTankReports();
          }
        }
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getTankReports();
      }
    },
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    getTankReports() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/TankSales/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          let index = 0;

          let series = [];
          var volumeSoldarr = [
            { name: this.$t("text.tankReport.volumeSold"), data: [] },
          ];
          var volumeFilledArr = [
            { name: this.$t("text.tankReport.volumeFilled"), data: [] },
          ];
          let cats = [];

          response.data.forEach((el) => {
            volumeSoldarr[0].data.push(parseFloat(el.volumeSold.toFixed(2)));
            volumeFilledArr[0].data.push(
              parseFloat(el.volumeFilled.toFixed(2))
            );
            cats.push(el.tankName);
          });

          this.tankReportsSplineOption.series = [
            ...volumeSoldarr,
            ...volumeFilledArr,
          ];
          this.tankReportsSplineOption.xAxis.categories = cats;

          response.data.forEach((element) => {
            element.index = ++index;
          });

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style>
@media screen and (max-width: 768px) {
  .drop_down_div.align-items-center.tank-report-dropdown {
    margin-top: -76px;
  }
}
</style>
